<template>
  <div class="typeform-shoppping">
    <!-- TypeFormCode -->
    <a
      class="typeform-share button typeform-share-hidden"
      :href="finalUrl"
      data-mode="drawer_right"
      data-auto-open="true"
      data-submit-close-delay="10"
    ></a>
  </div>
</template>

<script>
import loadingViewMixin from '@/mixins/loadingViewMixin'
import walletDataMixin from '@/mixins/walletDataMixin'

import WalletApi from '@/lib/api/Wallet'

export default {
  mixins: [loadingViewMixin, walletDataMixin],

  computed: {
    wedSiteInfo() {
      return this.$store.state.app.wedSiteInfo
    },
  },

  data() {
    return {
      baseUrl: 'https://casarcom.typeform.com/to/F4aOc9It#',
      params: {
        id: '',
        fiance1: '',
        fiance2: '',
        phone1: '',
        phone2: '',
        email: '',
        saldo: '',
        lista_externa: '',
        quantidade_compra: '',
      },
      finalUrl: '',
      balance: 0,
    }
  },

  async mounted() {
    const wallet = new WalletApi(this.logonToken)

    if (this.walletSummary.loading)
      this.walletSummary = await wallet.getSummary()

    this.balance = this.walletSummary.balance || 0

    if (this.wedSiteInfo) {
      this.setParamsToUrl()
      this.getWithdrawReason()
    }
  },

  methods: {
    setParamsToUrl() {
      this.params.id =
        'wed_id=' +
        (this.logonToken.token_payload.wed_id
          ? this.logonToken.token_payload.wed_id
          : '')

      this.params.fiance1 =
        'noivo1=' +
        (this.wedSiteInfo.noivo1_nome ? this.wedSiteInfo.noivo1_nome : '')

      this.params.fiance2 =
        'noivo2=' +
        (this.wedSiteInfo.noivo2_nome ? this.wedSiteInfo.noivo2_nome : '')

      this.params.phone1 =
        'fone1=' +
        (this.wedSiteInfo.contato_fone1 ? this.wedSiteInfo.contato_fone1 : '')

      this.params.phone2 =
        'fone2=' +
        (this.wedSiteInfo.contato_fone2 ? this.wedSiteInfo.contato_fone2 : '')

      this.params.email =
        'email=' +
        (this.wedSiteInfo.site_email ? this.wedSiteInfo.site_email : '')

      this.params.balance = 'saldo=' + (this.balance ? this.balance : '0')

      this.params.has_external_gift_list =
        'lista_externa=' +
        (this.wedSiteInfo.has_external_gift_list
          ? this.wedSiteInfo.has_external_gift_list
          : false)

      this.quantidade_compra =
        this.walletSummary.balance_shopping > 0
          ? `'&quantidade_compra='${this.walletSummary.count_shopping}`
          : '&quantidade_compra=0'

      this.finalUrl =
        this.baseUrl +
        this.params.id +
        '&' +
        this.params.fiance1 +
        '&' +
        this.params.fiance2 +
        '&' +
        this.params.phone1 +
        '&' +
        this.params.phone2 +
        '&' +
        this.params.email +
        '&' +
        this.params.balance +
        '&' +
        this.params.has_external_gift_list +
        this.quantidade_compra
    },
    getWithdrawReason() {
      //TypeFormCode
      let js,
        q,
        d = document,
        gi = d.getElementById,
        ce = d.createElement,
        gt = d.getElementsByTagName,
        id = 'typef_orm_share',
        b = 'https://embed.typeform.com/'
      if (!gi.call(d, id)) {
        js = ce.call(d, 'script')
        js.id = id
        js.src = b + 'embed.js'
        q = gt.call(d, 'script')[0]
        q.parentNode.insertBefore(js, q)
      }
    },
  },
}
</script>

<style lang="scss">
.iWhidq {
  width: 75% !important;
}
.egjIYz {
  //display: none !important;
}
</style>
